import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";

import Auth from "./layouts/Auth";

import Dashboard from "./layouts/Dashboard";
import NewHome from "./pages/Home/new";
import BookingStatus from "./pages/BookingStatus/BookingStatus";

import NotFound from "./pages/NotFound";
import Login from "./pages/Login/Login";
import LoginEmployee from "./pages/Login/LoginEmployee";
import ForgotPin from "./pages/ForgotPin/ForgotPin";
import ForgotOtp from "./pages/ForgotPin/ForgotOtp";
import ForgotReset from "./pages/ForgotPin/ForgotReset";
import ForgotSuccess from "./pages/ForgotPin/ForgotSuccess";
import SignUp from "./pages/SignUp/SignUp";
import SignUpOtp from "./pages/SignUp/SignUpOtp";
import SignUpNewPin from "./pages/SignUp/SignUpNewPin";
import SignUpComplete from "./pages/SignUp/SignUpComplete";

import SelectFlight from "./pages/Home/SelectFlight";
import MyProfile from "./pages/MyProfile";
import ConfirmBookingStatus from "./pages/ConfirmBookingStatus";
import ConfirmRequest from "./pages/ConfirmRequest";
import ChangePin from "./pages/ChangePin";
import { BookingContext } from "./contexts/BookingContext";
import { PaxContext } from "./contexts/PassengerContext";
import { GuestContext } from "./contexts/GuestContext";
import { LoaderContext } from "./contexts/loaderContext";
import { useEffect, useState } from "react";
import { SpinnerLoader } from "./components/SpinnerLoader";
import { DestinationContext } from "./contexts/DestinationContext";
import { ExtraFieldsContext } from "./contexts/ExtraFieldsContext";
import { useIsAuthenticated } from "@azure/msal-react";
import FAQs from "./pages/FAQs";
import Notification from "./firebaseNotifications/Notification";
import BusinessTripHome from "./pages/BusinessTripPages/BusinessTripHome";
import { BizTripBookingContext } from "./contexts/BizTripBookingContext";
import { INITIALIZE_BIZ_TRIP_FORM } from "./constants";
import { ProfileContext } from "./contexts/ProfileContext";

function App() {
  const [newUser, setNewUser] = useState(false);
  const [firstLaunch, setFirstLaunch] = useState(null);
  const isAuthenticated = useIsAuthenticated();
  const [booking, setBooking] = useState({
    from: "",
    to: "",
    departureDate: "",
    returnDate: "",
    returnTime: "",
    departureTime: "",
    perferAirline: [
      { label: "Srilankan Airlines", selected: false },
      { label: "Nepal Airlines", selected: false },
      { label: "Bangladesh Airlines", selected: false },
      { label: "Air India", selected: false },
      { label: "Egypt Air", selected: false },
      { label: "Philippines Airlines", selected: false },
      { label: "Indigo", selected: false },
      { label: "Turkish Airlines", selected: false },
      { label: "Royal Jordanian", selected: false },
      { label: "Air Cairo", selected: false },
      { label: "Emirates Airlines", selected: false },
      { label: "Kuwait Airways", selected: false },
      { label: "Pakistan Airlines", selected: false },
      { label: "Middle East Airlines", selected: false },
      { label: "Fly Dubai", selected: false },
      { label: "Saudi Airlines", selected: false },
      { label: "Qatar Airways", selected: false },
      { label: "Gulf Air", selected: false },
      { label: "Etihad Airlines", selected: false },
    ],
    directFlight: false,
    returnJourney: true,
    bookingComments: "",
  });
  const [bizData, setBizData] = useState([{ ...INITIALIZE_BIZ_TRIP_FORM }]);
  const [activeTripType, setActiveTripType] = useState("One Way");
  const [userData, setUserData] = useState({});

  const [destinations, setDestinations] = useState([]);
  const [guests, setGuests] = useState([]);
  const [passengers, setPax] = useState([]);
  const [profile, setProfile] = useState({});
  const [loading, setLoader] = useState(false);
  const [extraFields, setExtraFields] = useState({
    passportFileNames: [],
    contactNum: "",
    sapErrorList: [],
    companyCode: "",
    departmentCode: "",
    categoryType: "",
    isDisclaimer: "",
    selfPaidModalShown: false,
    exceptionNationModalShown: false,
    newNotificationCount: 0,
    companyName: "",
  });

  return (
    <LoaderContext.Provider value={{ loading, setLoader }}>
      {loading && <SpinnerLoader />}
      <DestinationContext.Provider value={{ destinations, setDestinations }}>
        <ProfileContext.Provider value={{ profile, setProfile }}>
          <BizTripBookingContext.Provider
            value={{
              bizData,
              setBizData,
              activeTripType,
              setActiveTripType,
              setUserData,
              userData,
            }}
          >
            <BookingContext.Provider value={{ booking, setBooking }}>
              <PaxContext.Provider value={{ passengers, setPax }}>
                <GuestContext.Provider value={{ guests, setGuests }}>
                  <ExtraFieldsContext.Provider
                    value={{ extraFields, setExtraFields }}
                  >
                    <Notification />
                    <Routes>
                      <Route path="auth" element={<Auth />}>
                        <Route path="login" element={<Login />} />
                        <Route
                          path="login/employee"
                          element={<LoginEmployee />}
                        />
                        <Route path="forgot" element={<ForgotPin />} />
                        <Route path="forgot/otp" element={<ForgotOtp />} />
                        <Route path="forgot/reset" element={<ForgotReset />} />
                        <Route
                          path="forgot/success"
                          element={<ForgotSuccess />}
                        />
                        <Route path="signup" element={<SignUp />} />
                        <Route path="signup/otp" element={<SignUpOtp />} />
                        <Route path="signup/pin" element={<SignUpNewPin />} />
                        <Route
                          path="signup/complete"
                          element={<SignUpComplete />}
                        />
                        <Route
                          index
                          element={<Navigate to={"login"} replace={true} />}
                        />
                      </Route>
                      <Route path="user" element={<Dashboard />}>
                        <Route path="dashboard" element={<NewHome />} />
                        <Route
                          path="dashboard/confirmRequest"
                          element={<ConfirmRequest />}
                        />
                        {/* <Route path="dashboard-new" element={<NewHome />} /> */}
                        <Route
                          path="dashboard/flights"
                          element={<SelectFlight />}
                        />
                        {/* <Route path="dashboard" element={<Home />} /> */}
                        {/* <Route
                  path="dashboard/flight-listing"
                  element={<SelectFlight />}
                /> */}
                        <Route path="bookings" element={<BookingStatus />} />
                        <Route
                          path="edit-business-trip/:id"
                          element={<BusinessTripHome />}
                        />
                        <Route
                          path="bookings/status/:id"
                          element={<ConfirmBookingStatus />}
                        />
                        <Route path="profile" element={<MyProfile />} />
                        <Route path="faqs" element={<FAQs />} />
                        <Route
                          path="dashboard/confirm-flights"
                          element={<ConfirmBookingStatus />}
                        />
                        <Route path="business" element={<BusinessTripHome />} />
                        {/* <Route path="entitlements" element={<EntitlementHistory />} /> */}
                        {!isAuthenticated && (
                          <Route path="pin" element={<ChangePin />} />
                        )}
                        <Route
                          index
                          element={<Navigate to="dashboard" replace={true} />}
                        />
                      </Route>
                      <Route
                        index
                        element={<Navigate to={"auth"} replace={true} />}
                      />
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </ExtraFieldsContext.Provider>
                </GuestContext.Provider>
              </PaxContext.Provider>
            </BookingContext.Provider>
          </BizTripBookingContext.Provider>
        </ProfileContext.Provider>
      </DestinationContext.Provider>
    </LoaderContext.Provider>
  );
}

export default App;
